import { moduleProviderFactory } from "mrb/core";
import { HomeStation, HomePodcast, HomePodcastGroup } from "application/home/pages";
import { TorahAnytime, TorahAnytimeWizard } from "application/torah-anytime/pages";
import { HomeStationRouteStore, HomePodcastRouteStore, HomePodcastGroupRouteStore } from "application/home/stores";
import { TorahAnytimeRouteStore, TorahAnytimeWizardRouteStore } from "application/torah-anytime/stores";

(function () {
    moduleProviderFactory.module("application").register({
        name: "application.home",
        routes: [
            {
                name: "master.application.home",
                pattern: "/home",
                children: [
                    // {
                    //     name: "master.application.home.list",
                    //     pattern: "",
                    //     component: Home,
                    //     store: HomeRouteStore,
                    //     data: {
                    //         title: "APPLICATION.HOME.LIST.TITLE",
                    //     },
                    // },
                    {
                        name: "master.application.home.station",
                        pattern: "/station/:id",
                        authorization: ["$premium-only$"],
                        component: HomeStation,
                        store: HomeStationRouteStore,
                    },
                    {
                        name: "master.application.home.podcast",
                        pattern: "/podcast/:id",
                        authorization: ["$premium-only$"],
                        component: HomePodcast,
                        store: HomePodcastRouteStore,
                    },
                    {
                        name: "master.application.home.podcast-group",
                        pattern: "/podcast/:id/group",
                        authorization: ["$premium-only$"],
                        component: HomePodcastGroup,
                        store: HomePodcastGroupRouteStore,
                    },
                    {
                        name: "master.application.home.torah-anytime",
                        pattern: "/torahanytime/:id",
                        authorization: ["$premium-only$"],
                        component: TorahAnytime,
                        store: TorahAnytimeRouteStore,
                    },
                    {
                        name: "master.application.home.torah-anytime.create",
                        pattern: "torahanytime/:id/collection/create",
                        authorization: ["$premium-only$"],
                        component: TorahAnytimeWizard,
                        store: TorahAnytimeWizardRouteStore,
                    },
                    {
                        name: "master.application.home.torah-anytime.edit",
                        pattern: "/torahanytime/:id/collection/:collectionId/edit",
                        authorization: ["$premium-only$"],
                        component: TorahAnytimeWizard,
                        store: TorahAnytimeWizardRouteStore,
                    },
                ],
            },
        ],
    });
})();
